function Calculator() {
    return (
        <div>
            <h2>Calculator</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default Calculator;